export default "__VITE_ASSET__CaIOj_cm__"